export default function FlexiblePageWrapper({ children }) {
  return (
    <div className="bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark min-h-screen flex flex-col items-center justify-center">
      {children}
    </div>
  );
}
